import { defineMessages } from 'react-intl';

export default defineMessages({
  contractEtGarantie: {
    id: 'auto_details.contract_garantie',
  },
  suiviDeSinistre: {
    id: 'auto_details.suivi_sinistre',
  },
  auto: {
    id: 'auto_details.auto',
  },
  habitation: {
    id: 'bread_crumbs.habitation',
  },
  myContractsAndGuarantees: {
    id: 'bread_crumbs.my_contracts_and_guarantees',
  },
  epargn: {
    id: 'bread_crumbs.epargn',
  },
  mesReleveDeSituation: {
    id: 'dashboard_epargn.releve_situation',
  },
  mesContrats: {
    id: 'dashboard_epargn.contrats',
  },
  autoServices: {
    id: 'auto.services',
  },
  mesRemboursements: {
    id: 'amc_details.my_refunds',
  },
  amc: {
    id: 'amc_details.amc',
  },
  asi: {
    id: 'asi_details.asi',
  },
  suiviDesDemandes: {
    id: 'amc_details.requests_follow_up',
  },
});
